.input {
  border-radius: var(--mantine-radius-sm);
  border: 1px solid var(--mantine-color-gray-2);
  &[data-error] {
    border: 1px solid var(--mantine-color-red-6);
  }
}

.option {
  padding: var(--tfg-molecule-padding-y) var(--tfg-molecule-padding-x);
}
